import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  CREATE_STORE_FORM_ACTION,
  STORE_ACTION_ENUM
} from "@app/features/store-invitation/create-store/create-store.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DataService} from "@shared/services/data.service";

@Component({
  selector: 'app-store-details-form',
  templateUrl: './store-details-form.component.html',
  styleUrls: ['./store-details-form.component.scss']
})
export class StoreDetailsFormComponent implements OnInit {
  @Output() handelAction: EventEmitter<CREATE_STORE_FORM_ACTION> = new EventEmitter<CREATE_STORE_FORM_ACTION>();
  @Input() data: any;
  public categoryList: any = [];
  public logoFileToUpload: any;
  logoFileReader: FileReader = new FileReader();
  public logoPreview: string | ArrayBuffer | null | undefined;
  public submitted: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private dataService: DataService) {
  }

  ngOnInit(): void {
    this.logoFileReader.onload = () => {
      this.logoPreview = this.logoFileReader.result;
    };
    this.registerForm = this.formBuilder.group({
      cat: [this.data?.storeCategory?.id ?? '', [Validators.required]],
      logo: [this.data?.storeLogoImageUrl ?? ''],
    });
    if (this.data?.storeLogoImageUrl){
      this.logoPreview = this.data?.storeLogoImageUrl;
    }
    this.initCategories();
  }

  public registerForm: any = FormGroup;

  get f() {
    return this.registerForm.controls;
  }

  public onSubmit(back = false) {
    if (back) {
      const action: CREATE_STORE_FORM_ACTION = {
        selectedIndex: 3,
        data: this.registerForm.getRawValue(),
        action: STORE_ACTION_ENUM.back
      }
      this.handelAction.emit(action);
      return;
    }
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    const action: CREATE_STORE_FORM_ACTION = {
      selectedIndex: 3,
      data: this.registerForm.getRawValue(),
      action: STORE_ACTION_ENUM.next
    }
    this.handelAction.emit(action)
  }

  public initCategories() {
    this.dataService.getStoreCategories().subscribe((next: any) => {
        this.categoryList = next?.content;
      },
      error => {
        console.log(error);
      })
  }

  public onLogoChange(event: { target: any; }) {
    const input = event.target;
    if (input.files && input.files[0]) {
      this.logoFileReader.readAsDataURL(input.files[0]);
      this.logoFileToUpload = input.files[0];
      this.uploadLogo(this.logoFileToUpload).then((res: any) => {
        this.registerForm.controls.logo.setValue(res.fileUrl);
      })
    }
  }

  uploadLogo(file: any) {
    return this.dataService.uploadImage(file);
  }
}
